export default class Form {
  static init() {
    document.addEventListener('click', e => {
      const target = e.target;
      console.log('click', target, target.tagName, target.getAttribute('type'))

      if (target.tagName === 'BUTTON' && target.getAttribute('type') === 'submit') {
        console.log('click submit button', target.closest('.form'))
        target.closest('.form')?.classList.add('form--show-validations')
      }
    })
  }
}
